import { SectionPanelProps, SectionPanel } from 'component-library';
import { Panel } from '../panel';

export default function SectionPanelWithPanelOverride(props: SectionPanelProps) {
  return <SectionPanel {...props} panelComponent={Panel} />;
}
